module.exports = __webpack_public_path__ + "static/media/aust.a69e1b34.png";